export const isServer = (): boolean => {
	try {
		//@ts-ignore: It defined from webpack on the Jira
		return __SERVER__;
	} catch (error) {
		return (globalThis as any).__SERVER__ ?? false;
	}
};
